const initialState = {
  quoteDocument: [],
  quoteDocumentConfig: {
    sortOrder: [
      "cover_page",
      "coverletter",
      "introduction",
      "dealitem",
      "dealterm",
    ],
    coverletter: { enabled: false, content: "" },
    introduction: { enabled: false, content: "" },
    pageTitle: "Insert title here",
    selectedTemplate: "template-one",
  },
};

function QuoteDocumentReducer(state = initialState, action) {
  switch (action.type) {
    case "FETCH_QUOTE_DOCUMENT":
      return { ...state, quoteDocument: action.payload };
    case "REORDER_QUOTE_DOCUMENT":
      return { ...state, quoteDocument: action.payload };
    case "TOGGLE_QUOTE_TYPE":
      return { ...state, quoteDocument: action.payload };
    case "UPDATE_MODAL_CONTENT":
      return { ...state, quoteDocument: action.payload };
    case "UPDATE_PAGE_TITLE":
      return { ...state, quoteDocumentConfig: action.payload };
    case "UPDATE_PAGE_TEMPLATE":
      return { ...state, quoteDocumentConfig: action.payload };
    case "REORDER_QUOTE_DOCUMENT_ORDER":
      return { ...state, quoteDocumentConfig: action.payload };
    case "TOGGLE_QUOTE_TYPE_CONFIG":
      return { ...state, quoteDocumentConfig: action.payload };
    default:
      return state;
  }
}

export default QuoteDocumentReducer;
